export default "__VITE_ASSET__BHrafOXh__"